import { ResourcesConfig } from "aws-amplify";

export const awsconfig: ResourcesConfig = {
  API: {
    Events: {
      endpoint: `https://${process.env.REACT_APP_APPSYNC_HTTP_URL}/event`,
      region: process.env.REACT_APP_APPSYNC_REGION,
      defaultAuthMode: "userPool",
    },
  },
  Auth: {
    Cognito: {
      //  Amazon Cognito User Pool ID
      userPoolId: process.env.REACT_APP_AWS_AUTH_USER_POOL_ID || "",
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolClientId:
        process.env.REACT_APP_AWS_AUTH_USER_POOL_WEB_CLIENT_ID || "",
      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      identityPoolId: "",
      // OPTIONAL - Set to true to use your identity pool's unauthenticated role when user is not logged in
      allowGuestAccess: true,
      // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
      // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
      signUpVerificationMethod: "code", // 'code' | 'link'
      loginWith: {
        // OPTIONAL - Hosted UI configuration
        oauth: {
          domain: process.env.REACT_APP_AWS_AUTH_OAUTH_DOMAIN || "",
          scopes: [],
          redirectSignIn: [
            process.env.REACT_APP_AWS_AUTH_OAUTH_REDIRECT_SIGN_IN || "",
          ],
          redirectSignOut: [
            process.env.REACT_APP_AWS_AUTH_OAUTH_REDIRECT_SIGN_OUT || "",
          ],
          responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
};
